export const SUCCESS = {
  DARK: '#007500',
  DEFAULT: '#049404',
  LIGHT: '#92ee96',
  LIGHTER: '#b6fdb7',
} as const;
